import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgDialogsModule, NgInputsModule, NgStylingComponentsModule } from '@libs/frameworks/angular';

import { SparkHeaderComponent } from './header/header.component';
import { SparkSidebarComponent } from './sidebar/sidebar.component';
import { SparkFooterComponent } from './footer/footer.component';
import { SparkSidebarNavigationService } from '../../services/sidebar-navigation/sidebar-navigation.service';


@NgModule({
	imports: [
		CommonModule,
		NgbCollapseModule,
		NgbDropdownModule,
		RouterModule,
		NgStylingComponentsModule,
		NgDialogsModule,
		NgInputsModule
	],
	declarations: [
		SparkSidebarComponent,
		SparkHeaderComponent,
		SparkFooterComponent
	],
	providers: [
		SparkSidebarNavigationService
	],
	exports: [
		SparkSidebarComponent,
		SparkHeaderComponent,
		SparkFooterComponent
	]
})
export class SparkLayoutModule {}
